<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'TechnologyCenter',
            to: {
              name: 'TechnologyCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'TechnologyCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增技術</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增技術 -->
    <TechnologyCreateEdit></TechnologyCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TechnologyCreateEdit from '@/views/E-7__Technology/c/TechnologyCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    TechnologyCreateEdit,
  },
  computed: {
    ...mapState('technology', ['technology']),
  },
  created() {
    this.setTechnology({});
  },
  methods: {
    ...mapActions('technology', ['setTechnology', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'TechnologyCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.technology.title) {
          this.errors.push('標題 required.');
        } else if (!this.technology.bu_technology_id) {
          this.errors.push('技術類別 required.');
        } else if (!this.technology.slug) {
          this.errors.push('Slug required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.technology).then(() => {
          this.$router.push({ name: 'TechnologyCenter' });
        });
      }
    },
  },
};
</script>
<style></style>
